import { DEFAULT_THEME } from '@zendeskgarden/react-theming';

export const breakpoints = {
  xl: 1200,
  lg: 992,
  md: 768,
  sm: 576,
  xs: 0,
};

const theme = {
  ...DEFAULT_THEME,
  colors: {
    ...DEFAULT_THEME.colors,
    primary: DEFAULT_THEME.palette.blue[700],
  },
  fonts: {
    ...DEFAULT_THEME.fonts,
    mono: "Inter, sans-serif",
  },
  palette: {
    ...DEFAULT_THEME.palette,
  },
};

export default theme;
